import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, tap } from "rxjs";
import { ScrEnvironment } from "src/environments/environment";
import { BillingOrder } from "../models/billingorder.model";
import { AchPaymentMethod, Card, Payment } from "../models/payment.model";
import { WITHCRED, WithCredNoCache } from "./authentication.service";
import { IScrBaseResponse, ScrBaseService } from "./base.service";
import { ScrServiceManager } from "./servicemanager.service";

export class InitiateMultiOrderPaymentRequest {
  public orderIds: number[] = [];
}

export interface InitialMultiOrderPaymentResponse extends IScrBaseResponse {
  payment?: Payment;
}


export interface IPaymentMetadata {
  sourceType: string;
  anyMb: boolean;
  orderCount: number;
}
export interface IPaymentResponse extends IScrBaseResponse {

  /**
   * Upon success, the payment record.
   */
  payment: Payment;

  /**
   * When paying for credit and user does not have enough,
   * this value indicates what they do have on their account
   * in the event it changed since the previous query.
   */
  accountAvailableCredit?: number;

  meta: IPaymentMetadata;
}

/**
 * Allows for payment of multiple invoices as a Payment object.
 */

@Injectable({
  providedIn: 'root'
})
export class PaymentService extends ScrBaseService {
  constructor(
    serviceManager: ScrServiceManager,
    private environment: ScrEnvironment,
    private http: HttpClient) {
    super(serviceManager);

  }

  initiatePayment(orders: BillingOrder[]): Observable<InitialMultiOrderPaymentResponse> {
    const url = `${this.environment.base}/secure/payment/initiate`;
    return this.http.post<InitialMultiOrderPaymentResponse>(url, {
      orderIds: orders.map(o => o.orderId)
    },
      WITHCRED).pipe(tap((rsp: InitialMultiOrderPaymentResponse) => {
        if (rsp.payment) {

          // sort the contents and roll up all leases into the payment to help client.
          rsp.payment.orders?.sort((a, b) => a.orderId - b.orderId);
          rsp.payment.orders?.forEach(o => {
            if (o.leases) {
              o.leases.sort((a, b) => a.scId - b.scId);
            }
          });
        }
      }));
  }

  submitPayment(payment: Payment, cc?: Card, ach?: AchPaymentMethod, creditToBeApplied = 0): Observable<IPaymentResponse> {
    const url = `${this.environment.base}/fct/payment/submit`;
    const body = this.functionUrlBody('submit', { cc, ach, payment, creditToBeApplied });
    const strBody = JSON.stringify(body, ScrBaseService.phoneReplacer);
    return this.http.post<IPaymentResponse>(url, strBody, WITHCRED);
  }


  getPaymentForThankYou(paymentId: number | undefined, billingOrderId: number | undefined, monthlyInvoiceId: number | undefined): Observable<IPaymentResponse> {
    let url = `${this.environment.base}/secure/payment/thankyou`;
    if (paymentId) {
      url = url + `?paymentId=${paymentId}`;
    }
    else if (billingOrderId) {
      url = url + `?billingOrderId=${billingOrderId}`;
    }
    if (monthlyInvoiceId) {
      url = url + `?monthlyInvoiceId=${monthlyInvoiceId}`;
    }
    return this.http.get<IPaymentResponse>(url, WithCredNoCache);
  }

  getPayment(paymentId: number | undefined): Observable<IPaymentResponse> {

    let url = `${this.environment.base}/secure/payment/thankyou`;
    if (paymentId) {
      url = url + `?paymentId=${paymentId}`;
    }

    return this.http.get<IPaymentResponse>(url, WithCredNoCache);
  }
}